module.exports = __webpack_public_path__ + "img/img5.734ee9d8.svg";